import { createApp } from 'vue';
import WordToJpgConverter from '@/Components/WordToJpgConverter.vue';
import '@styles/app.css';

createApp(WordToJpgConverter).mount('#word-to-jpg-converter');
